/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042108-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqSharingApiClass {
 
   constructor() {}

  /**
   * @summary Archive or delete an organization. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the organization to archive or delete
   * @param {boolean} _delete=false - If true, the organization and its folder and user group will be deleted. Otherwise they will be archived.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public archiveOrDeleteOrganization(
    {
      id,
      _delete
    } : {
      id: string,
      _delete: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (_delete === null || _delete === undefined) {
      throw new Error("'_delete' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/sharing/organizations/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/sharing/organizations/{id}`;

    const queryParams = {
      ['delete']: _delete
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Create an organization. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createOrganization(
    body: models.OrganizationInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/sharing/organizations`;
    const urlTemplate = `${baseUrl}/sharing/organizations`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.OrganizationOutputV1>;
  }

  /**
   * @summary Get an organization. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the organization to retrieve
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getOrganizationById(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/sharing/organizations/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/sharing/organizations/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.OrganizationOutputV1>;
  }

  /**
   * @summary Get a collection of organizations. This endpoint is experimental and may change in future releases.
   * @param {string} [nameSearch] - Search text by which to filter organizations&#x27; names.
   * @param {boolean} [isEnabled] - Return only organizations that have the specified value for Enabled.
   * @param {boolean} [isArchived] - Return only organizations that match the specified archive status. If not provided, returns all organizations regardless of archive status.
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getOrganizations(
    {
      nameSearch,
      isEnabled,
      isArchived,
      offset,
      limit
    } : {
      nameSearch?: string,
      isEnabled?: boolean,
      isArchived?: boolean,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/sharing/organizations`;
    const urlTemplate = `${baseUrl}/sharing/organizations`;

    const queryParams = {
      ['nameSearch']: nameSearch,      ['isEnabled']: isEnabled,      ['isArchived']: isArchived,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetOrganizationsOutputV1>;
  }

  /**
   * @summary Unarchive an organization. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the organization to unarchive
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public unarchiveOrganization(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/sharing/organizations/${encodeURIComponent(String(id))}/unarchive`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/sharing/organizations/{id}/unarchive`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Update an organization. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the organization to update
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateOrganization(
    body: models.OrganizationInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/sharing/organizations/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/sharing/organizations/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.OrganizationOutputV1>;
  }

}


export const sqSharingApi = new sqSharingApiClass();

export type sqSharingApiEndpoints = {
  'archiveOrDeleteOrganization': {
    method: 'delete';
    path: '/sharing/organizations/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'createOrganization': {
    method: 'post';
    path: '/sharing/organizations';
    response: models.OrganizationOutputV1;
  };
  'getOrganizationById': {
    method: 'get';
    path: '/sharing/organizations/${encodeURIComponent(String(id))}';
    response: models.OrganizationOutputV1;
  };
  'getOrganizations': {
    method: 'get';
    path: '/sharing/organizations';
    response: models.GetOrganizationsOutputV1;
  };
  'unarchiveOrganization': {
    method: 'post';
    path: '/sharing/organizations/${encodeURIComponent(String(id))}/unarchive';
    response: models.StatusMessageBase;
  };
  'updateOrganization': {
    method: 'post';
    path: '/sharing/organizations/${encodeURIComponent(String(id))}';
    response: models.OrganizationOutputV1;
  };
};

type ApiArchiveOrDeleteOrganizationResponse = models.StatusMessageBase;
type ApiarchiveOrDeleteOrganizationMutationParams = Parameters<typeof sqSharingApi.archiveOrDeleteOrganization> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSharingApi.archiveOrDeleteOrganization>;

export function useApiArchiveOrDeleteOrganizationMutation(
  options?: Omit<UseMutationOptions<ApiArchiveOrDeleteOrganizationResponse, AxiosError<SeeqErrorData>,
    ApiarchiveOrDeleteOrganizationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveOrDeleteOrganizationResponse, AxiosError<SeeqErrorData>,
  ApiarchiveOrDeleteOrganizationMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveOrDeleteOrganizationMutationParams) =>
      sqSharingApi.archiveOrDeleteOrganization(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateOrganizationResponse = models.OrganizationOutputV1;
type ApicreateOrganizationMutationParams = Parameters<typeof sqSharingApi.createOrganization> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSharingApi.createOrganization>;
type ApicreateOrganizationMutationVariables = models.OrganizationInputV1;

export function useApiCreateOrganizationMutation(
  options?: Omit<UseMutationOptions<ApiCreateOrganizationResponse, AxiosError<SeeqErrorData>,
    ApicreateOrganizationMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateOrganizationResponse, AxiosError<SeeqErrorData>,
  ApicreateOrganizationMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateOrganizationMutationVariables) =>
      sqSharingApi.createOrganization(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetOrganizationByIdResponse = models.OrganizationOutputV1;
export function GetOrganizationByIdQueryKey(
  params: Parameters<typeof sqSharingApi.getOrganizationById>[0],
) {
  return ['sqSharingApi', 'getOrganizationById', params] as const;
}

export function useApiGetOrganizationByIdQuery(
  params: Parameters<typeof sqSharingApi.getOrganizationById>[0],
  options?: Omit<UseQueryOptions<ApiGetOrganizationByIdResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetOrganizationByIdResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetOrganizationByIdQueryKey(params),
    queryFn: () =>
      sqSharingApi.getOrganizationById(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetOrganizationsResponse = models.GetOrganizationsOutputV1;
export function GetOrganizationsQueryKey(
  params: Parameters<typeof sqSharingApi.getOrganizations>[0],
) {
  return ['sqSharingApi', 'getOrganizations', params] as const;
}

export function useApiGetOrganizationsQuery(
  params: Parameters<typeof sqSharingApi.getOrganizations>[0],
  options?: Omit<UseQueryOptions<ApiGetOrganizationsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetOrganizationsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetOrganizationsQueryKey(params),
    queryFn: () =>
      sqSharingApi.getOrganizations(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUnarchiveOrganizationResponse = models.StatusMessageBase;
type ApiunarchiveOrganizationMutationParams = Parameters<typeof sqSharingApi.unarchiveOrganization> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSharingApi.unarchiveOrganization>;

export function useApiUnarchiveOrganizationMutation(
  options?: Omit<UseMutationOptions<ApiUnarchiveOrganizationResponse, AxiosError<SeeqErrorData>,
    ApiunarchiveOrganizationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUnarchiveOrganizationResponse, AxiosError<SeeqErrorData>,
  ApiunarchiveOrganizationMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiunarchiveOrganizationMutationParams) =>
      sqSharingApi.unarchiveOrganization(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateOrganizationResponse = models.OrganizationOutputV1;
type ApiupdateOrganizationMutationParams = Parameters<typeof sqSharingApi.updateOrganization> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSharingApi.updateOrganization>;

export function useApiUpdateOrganizationMutation(
  options?: Omit<UseMutationOptions<ApiUpdateOrganizationResponse, AxiosError<SeeqErrorData>,
    ApiupdateOrganizationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateOrganizationResponse, AxiosError<SeeqErrorData>,
  ApiupdateOrganizationMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateOrganizationMutationParams) =>
      sqSharingApi.updateOrganization(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
